import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingSubtitle', 'LandingAgeGrid'],

	components: {
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: '28-Day MAT Pilates Challenge',
			size: 'large',
			uppercase: true,
		}),

		LandingSubtitle: ({ $t }): LandingComponentsConfig['LandingSubtitle'] => ({
			uppercase: true,
			title: $t('female_activity.pages.landing.step_1.subtitle', {
				age: `<b>${$t('female_activity.pages.landing.step_1.age')}</b>`,
			}),
		}),

		LandingAgeGrid: ({ $t }): LandingComponentsConfig['LandingAgeGrid'] => ({
			theme: 'purple',
			ageRanges: [
				{
					value: 18,
					analyticValue: '18-29',
					label: $t('female_activity.pages.landing.step_1.options.18_29'),
					img: require('@/assets/landing-activity-female/age-18.webp'),
				},
				{
					value: 30,
					analyticValue: '30-39',
					label: $t('female_activity.pages.landing.step_1.options.30_39'),
					img: require('@/assets/landing-activity-female/age-30.webp'),
				},
				{
					value: 40,
					analyticValue: '40-49',
					label: $t('female_activity.pages.landing.step_1.options.40_49'),
					img: require('@/assets/landing-activity-female/age-40.webp'),
				},
				{
					value: 50,
					analyticValue: '50-59',
					label: $t('female_activity.pages.landing.step_1.options.50'),
					img: require('@/assets/landing-activity-female/age-50.webp'),
				},
			],
		}),
	},
}

export default schema
